export const MAP_CONFIG = {
  defaultCenter: [45.77879159729645, -74.01142157234905] as [number, number],
  defaultZoom: 13,
  mobileZoom: 17,
  desktopZoom: 18,
  mobileBreakpoint: 768,
  // OpenStreetMap - Free, no API key required
  tileLayerUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  tileLayerAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  recenterDuration: 1,
  recenterDelay: 100,
} as const;

export const MOBILE_PADDING = {
  paddingTopLeft: [150, 50] as [number, number],
  paddingBottomRight: [150, 180] as [number, number],
} as const;

export const DESKTOP_PADDING = {
  paddingTopLeft: [0, 50] as [number, number],
  paddingBottomRight: [0, 100] as [number, number],
} as const;
